// src/components/common/ImageZoomModal.jsx
import React, { useState, useEffect, useRef } from "react";

export default function ImageZoomModal({ src, onClose }) {
  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const dragStart = useRef({ x: 0, y: 0 });

  /* ================= ESC FECHA ================= */
  useEffect(() => {
    const esc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onClose]);

  /* ================= ZOOM COM SCROLL ================= */
  const handleWheel = (e) => {
    e.preventDefault();
    setZoom((z) =>
      Math.min(3, Math.max(1, z + (e.deltaY < 0 ? 0.1 : -0.1)))
    );
  };

  /* ================= DRAG ================= */
  const handleMouseDown = (e) => {
    setDragging(true);
    dragStart.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y
    };
  };

  const handleMouseMove = (e) => {
    if (!dragging) return;
    setPosition({
      x: e.clientX - dragStart.current.x,
      y: e.clientY - dragStart.current.y
    });
  };

  const handleMouseUp = () => setDragging(false);

  /* ================= RESET QUANDO ABRE ================= */
  useEffect(() => {
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  }, [src]);

  return (
    <div
      className="fixed inset-0 bg-black/90 z-[9999] flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className="relative w-full h-full flex items-center justify-center"
        onClick={(e) => e.stopPropagation()}
        onWheel={handleWheel}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >
        {/* BOTÃO FECHAR */}
        <button
          onClick={onClose}
          className="absolute top-6 right-6 z-50 bg-white/90 text-gray-800 rounded-full p-2 hover:bg-white shadow-lg"
        >
          ✕
        </button>

        {/* CONTAINER FIXO DA IMAGEM */}
        <div
          className="bg-black flex items-center justify-center overflow-hidden rounded-xl shadow-2xl"
          style={{
            width: "800px",
            height: "400px",
            maxWidth: "90vw",
            maxHeight: "80vh"
          }}
        >
          <img
            src={src}
            alt="Zoom"
            draggable={false}
            onMouseDown={handleMouseDown}
            style={{
              transform: `translate(${position.x}px, ${position.y}px) scale(${zoom})`,
              cursor: dragging ? "grabbing" : "grab"
            }}
            className="w-full h-full object-contain select-none transition-transform duration-75"
          />
        </div>

        {/* CONTROLE DE ZOOM */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 bg-black/70 backdrop-blur-md rounded-2xl px-6 py-4 w-[340px] shadow-xl">
          <div className="flex justify-between text-xs text-gray-300 mb-2">
            <span>Min</span>
            <span className="font-bold text-white">
              {Math.round(zoom * 100)}%
            </span>
            <span>Max</span>
          </div>

          <input
            type="range"
            min="1"
            max="3"
            step="0.01"
            value={zoom}
            onChange={(e) => setZoom(Number(e.target.value))}
            className="w-full accent-indigo-500"
          />
        </div>
      </div>
    </div>
  );
}
